import React from "react";
import { injectIntl } from "react-intl";
import { Row, Col, Table, Button } from "react-bootstrap";

@injectIntl
export default class AffiliationTableHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <thead>
        <tr>
          {this.props.titles.map((e, idx) => {
            return (
              <td key={idx}>
                <b>{this.props.intl.formatMessage({ id: e })}</b>
              </td>
            );
          })}
          <td>
            <b>{this.props.intl.formatMessage({ id: "resend" })}</b>
          </td>
        </tr>
      </thead>
    );
  }
}
